var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-row",
        { staticClass: "downloads-filter-row" },
        [
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-info", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", [
                    !_vm.filteredResults
                      ? _c("div", [
                          _c("h4", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(
                                _vm.filesInSystem
                                  ? _vm.filesInSystem.toLocaleString()
                                  : 0
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("Files")])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filteredResults
                      ? _c("div", [
                          _c("h4", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(_vm.filesFilteredCount) +
                                " of " +
                                _vm._s(
                                  _vm.filesInSystem
                                    ? _vm.filesInSystem.toLocaleString()
                                    : 0
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("Files")])
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-info", attrs: { "no-body": "" } },
                [
                  _c(
                    "b-card-body",
                    [
                      _c("h4", { staticClass: "mb-0" }, [_vm._v("Search")]),
                      _vm._v(" "),
                      _c("p", [_vm._v("By name")]),
                      _vm._v(" "),
                      _c(
                        "b-input-group",
                        [
                          _c("b-form-input", {
                            attrs: { placeholder: "Type to Search" },
                            on: {
                              keyup: function($event) {
                                return _vm.updateSearch()
                              }
                            },
                            model: {
                              value: _vm.textboxFilterValue,
                              callback: function($$v) {
                                _vm.textboxFilterValue = $$v
                              },
                              expression: "textboxFilterValue"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-input-group-addon",
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: { disabled: !_vm.filter },
                                  on: {
                                    click: function($event) {
                                      return _vm.resetSearchFilter()
                                    }
                                  }
                                },
                                [_vm._v("Clear")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "12" } }, [
            _c(
              "div",
              [
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.collapse1",
                        modifiers: { collapse1: true }
                      }
                    ],
                    attrs: { variant: "primary" }
                  },
                  [_vm._v("Filters")]
                ),
                _vm._v(" "),
                _c("b-btn", { on: { click: _vm.resetFilters } }, [
                  _vm._v("Clear Filters")
                ]),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  { staticClass: "mb-30", attrs: { id: "collapse1" } },
                  [
                    _c(
                      "b-card",
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "4" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "File Type",
                                      "label-for": "fileType"
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      staticClass: "mb-2 mr-sm-2 mb-sm-0",
                                      style: { width: "150px" },
                                      attrs: {
                                        id: "fileType",
                                        options: _vm.filterOptions
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.updateFilter()
                                        }
                                      },
                                      model: {
                                        value: _vm.dropdownFilterValue,
                                        callback: function($$v) {
                                          _vm.dropdownFilterValue = $$v
                                        },
                                        expression: "dropdownFilterValue"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-20" },
        [
          _c(
            "b-col",
            { attrs: { sm: "12" } },
            [
              _c(
                "b-card",
                [
                  _c("b-table", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.finishedLoading,
                        expression: "finishedLoading"
                      }
                    ],
                    attrs: {
                      filter: _vm.filter,
                      "filter-function": _vm.searchFilter,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection,
                      hover: true,
                      striped: true,
                      bordered: false,
                      small: true,
                      fixed: true,
                      responsive: "sm",
                      items: _vm.files,
                      fields: _vm.getTableFields(),
                      "per-page": 20,
                      "current-page": _vm.currentPage
                    },
                    on: {
                      "update:sortBy": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function($event) {
                        _vm.sortDesc = $event
                      },
                      filtered: _vm.onFiltered
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "fileName",
                        fn: function(item) {
                          return _c("div", {}, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: item.item.filePath,
                                  download: ""
                                }
                              },
                              [_vm._v(_vm._s(item.value))]
                            )
                          ])
                        }
                      },
                      {
                        key: "startDate",
                        fn: function(item) {
                          return _c("div", {}, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.item.context) +
                                "\n            "
                            )
                          ])
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("b-pagination", {
                    attrs: {
                      "total-rows": 6,
                      "prev-text": "Prev",
                      "next-text": "Next",
                      "current-page": _vm.currentPage
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5afca916", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afca916","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/Downloads.vue
// module id = 1930
// module chunks = 0